import styled, { css } from 'styled-components';

const sharedCss = css`
  background: rgba(231, 231, 231, 0.3);
  border-radius: 3px;
  border: 1px solid #d4d4d4;
  padding: 12px;
`;

export const HalfContainer = styled.div`
  display: block;
  margin: 0;
  margin-bottom: 1rem;
  ${sharedCss};
  :last-child {
    margin-bottom: 1.5rem;
  }
  h3 {
    padding-bottom: 1rem;
  }
`;

export const PreviewContainer = styled.div`
  display: block;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 1rem;
  ${sharedCss};
`;

export const Box = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  :last-child {
    margin-bottom: 0;
  }

  h4 {
    font-size: 12px;
    font-weight: 500;
    width: 45px;
    word-wrap: normal;
  }

  svg {
    transform: rotateZ(-90deg);
  }
`;

export const DateBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => (props.showOnModal ? '5px 0' : '5px 30px')};
  width: ${props => (props.showOnModal ? '100px' : 'auto')};
  justify-content: center;
  align-items: center;
  border: 1px solid #d4d4d4;
  font-weight: bold;
  span {
    font-weight: normal;
    margin: ${props => props.showOnModal && '0 5px'};
  }
`;
